import { Link, useLocation, useNavigate } from 'react-router-dom'

import './styles.css'
import { useEffect } from 'react'
import {
    useDeleteDevice,
    useGetDeviceConfig,
} from '../../../api/routes/devices'
import { authClient, hasPermission } from '../../../lib/auth-client'
import { DropdownMenu } from './dropdown-menu'
import { useBusinessModuleCheck } from '../../../api/routes/modules'

const Header = ({
    deviceId,
    name,
    businessId,
    onCreateNew,
}: {
    deviceId: string
    name: string
    businessId?: string
    onCreateNew?: () => void
}) => {
    const location = useLocation()
    const navigate = useNavigate()
    const {
        mutate: deleteDevice,
        isPending: isDeleting,
        isSuccess: deleteSuccess,
    } = useDeleteDevice()

    const { data: deviceConfig } = useGetDeviceConfig(deviceId)

    const handleDeleteDevice = () => {
        const confirmDelete = window.confirm(
            'Are you sure you want to delete this device?'
        )
        if (!confirmDelete) return

        deleteDevice(deviceId)
    }

    useEffect(() => {
        if (deleteSuccess) {
            navigate('/devices')
        }
    }, [deleteSuccess])

    const { data: session } = authClient.useSession()
    const user = session?.user as any
    const role = user?.role
    const { data: moduleAccess } = useBusinessModuleCheck(
        businessId || null,
        'device-config'
    )
    const hasDeviceConfig = !!moduleAccess?.hasAccess
    const { data: serviceModuleAccess } = useBusinessModuleCheck(
        businessId || null,
        'service'
    )
    const hasServiceModule = !!serviceModuleAccess?.hasAccess

    const handleCopyConfiguration = () => {
        alert('Configuration copied to clipboard')
        navigator.clipboard.writeText(JSON.stringify(deviceConfig, null, 2))
    }

    const tabs = [
        { label: 'Overview', path: `/devices/${deviceId}` },
        ...(hasServiceModule
            ? [{ label: 'Service', path: `/devices/${deviceId}/services` }]
            : []),
        { label: 'Live', path: `/devices/${deviceId}/live` },
        { label: 'Location', path: `/devices/${deviceId}/location` },
        { label: 'History', path: `/devices/${deviceId}/history` },
        { label: 'Errors', path: `/devices/${deviceId}/errors` },
        ...(hasDeviceConfig && role && hasPermission(role, { device: ['configure'] })
            ? [{ label: 'Settings', path: `/devices/${deviceId}/settings` }]
            : []),
    ]

    return (
        <div className="mb-6 sm:mb-8">
            <div className="flex items-center justify-between mb-4 sm:mb-6">
                <h1 className="text-xl sm:text-2xl font-semibold tracking-tight text-foreground">
                    {name}
                </h1>
            </div>

            <div className="flex items-center justify-between min-w-0">
                <nav className="flex items-center gap-1 rounded-lg bg-muted p-1 overflow-x-auto -mx-1 px-1 max-w-full scrollbar-none">
                    {tabs.map((tab) => {
                        const isActive = location.pathname === tab.path
                        return (
                            <Link
                                key={tab.path}
                                to={tab.path}
                                className={`
                                    px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-medium rounded-md transition-all duration-150 whitespace-nowrap flex-shrink-0
                                    ${
                                        isActive
                                            ? 'bg-card text-foreground shadow-sm'
                                            : 'text-muted-foreground hover:text-foreground'
                                    }
                                `}
                            >
                                {tab.label}
                            </Link>
                        )
                    })}
                </nav>

                {/* {role &&
                    hasPermission(role, { device: ['configure'] }) &&
                    location.pathname === `/devices/${deviceId}` && (
                        <DropdownMenu
                            items={[
                                {
                                    label: 'Copy Configuration',
                                    onClick: handleCopyConfiguration,
                                },
                                {
                                    line: true,
                                },
                                {
                                    label: 'Edit Device',
                                    onClick: () => {
                                        alert('Edit Device')
                                    },
                                },
                                {
                                    label: 'Delete Device',
                                    onClick: handleDeleteDevice,
                                },
                            ]}
                        />
                    )}

                {role &&
                    hasPermission(role, { device: ['configure'] }) &&
                    location.pathname === `/devices/${deviceId}/config` && (
                        <DropdownMenu
                            items={[
                                {
                                    label: 'Add Configuration',
                                    onClick: onCreateNew,
                                },
                                {
                                    label: 'Copy Configuration',
                                    onClick: handleCopyConfiguration,
                                },
                            ]}
                        />
                    )} */}
            </div>
        </div>
    )
}

export default Header
